import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input"]

  generate(event) {
    event.preventDefault()
    this.inputTarget.value = this.randomToken()
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  randomToken() {
    if (window.crypto?.getRandomValues) {
      const bytes = new Uint8Array(24)
      window.crypto.getRandomValues(bytes)
      return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("")
    }

    return `${Date.now().toString(16)}${Math.random().toString(16).slice(2)}`
  }
}
